import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import NotificationsSettingsPage from "components/pages/NotificationsSettingsPage";
import Classes, { ContactInfo } from "model";

export default function CaptureNotifiPhoneInList(props) {
    const controller = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, controller);

    ContactInfo.create({
        id: ContactInfo.nextID(),
        isPrimary: "false",
        isConfirmed: "true",
        value: "(231) 256-7890",
        userEnteredActivationCode: "1270837",
        type: "phone"
    }).submit(Classes);

    return <NotificationsSettingsPage />
}